<section class="hero">
  <div class="background">
    <div class="overlay"></div>
  </div>
  <div class="decorations">
    <div class="circle top-right"></div>
    <div class="circle bottom-left"></div>
  </div>

  <div class="auth-page-container">
    <div class="auth-card">
      <div class="auth-card__brand">
        <div class="auth-card__brand-icon"><mat-icon>point_of_sale</mat-icon></div>
        <span>Nova Point</span>
      </div>

      <div class="auth-card__icon">
        <mat-icon>mark_email_read</mat-icon>
      </div>

      <h1>Check your email</h1>
      <p class="subtitle">Enter the code we sent to <strong>{{ email }}</strong>, then choose a new password.</p>

      <form [formGroup]="form" (ngSubmit)="submit()" class="form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Reset code</mat-label>
          <input matInput formControlName="code" placeholder="123456" maxlength="6" inputmode="numeric" class="code-input" />
          <mat-icon matPrefix>pin</mat-icon>
          <mat-error *ngIf="form.get('code')?.hasError('required')">Enter the code we emailed you</mat-error>
          <mat-error *ngIf="form.get('code')?.hasError('pattern')">Enter the 6-digit code</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>New password</mat-label>
          <input matInput formControlName="newPassword" [type]="hidePassword ? 'password' : 'text'" autocomplete="new-password" />
          <mat-icon matPrefix>lock</mat-icon>
          <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="form.get('newPassword')?.hasError('required')">Password is required</mat-error>
          <mat-error *ngIf="form.get('newPassword')?.hasError('minlength')">Minimum 8 characters</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Confirm new password</mat-label>
          <input matInput formControlName="confirmPassword" [type]="hideConfirm ? 'password' : 'text'" autocomplete="new-password" />
          <mat-icon matPrefix>lock_outline</mat-icon>
          <button mat-icon-button matSuffix type="button" (click)="hideConfirm = !hideConfirm">
            <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <div class="password-mismatch" *ngIf="form.get('confirmPassword')?.touched && form.hasError('mismatch')">
          Passwords do not match
        </div>

        <button mat-raised-button type="submit" class="submit-button" [disabled]="!form.valid || loading">
          @if (loading) {
            <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
          } @else {
            Reset password
          }
        </button>
      </form>

      <button mat-button class="resend-link" [disabled]="resending" (click)="resendCode()">
        {{ resending ? 'Sending…' : "Didn't get a code? Resend" }}
      </button>
      <a routerLink="/landing" class="back-link">Back to login</a>
    </div>
  </div>
</section>
